export const MultiAssetIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M17.5 16.25H2.5V3.75" stroke="#A78BFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.625 5.625L10 11.25L7.5 8.75L2.5 13.75" stroke="#A78BFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.625 8.75V5.625H12.5" stroke="#A78BFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
